import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";

const initState = {
    name: '',
    emailAddress: '',
    password: '',
    confirmPassword: ''
};

export const BoardCommitteeFormData = {
    name: "Add Member Form",
    initialState: initState,
    section: [
        {
            title: "Add Member Section",
            row: {},
            style: {
                sectionStyle: "row mb-3 login-form",
            },

            fields: [
                {
                    id: "name",
                    label: "Name",
                    Field_Name: "Name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "name",
                    fieldSetting: {
                        placeholder: "Please Enter Name",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0 ",
                    },
                },
                {
                    id: "emailAddress",
                    label: "Email Address",
                    Field_Name: "Email Address",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "emailAddress",
                    fieldSetting: {
                        placeholder: "Please Enter User Name",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0 ",
                    },
                },
                {
                    id: "password",
                    label: "Password",
                    Field_Name: "Password",
                    fieldType: FormFieldTypes.PASSWORD,
                    dataField: "password",
                    fieldSetting: {
                        placeholder: "Please Enter Password",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0 ",
                    },
                },
                {
                    id: "confirmPassword",
                    label: "Confirm Password",
                    Field_Name: "Confirm Password",
                    fieldType: FormFieldTypes.PASSWORD,
                    dataField: "confirmPassword",
                    fieldSetting: {
                        placeholder: "Please Enter Password",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0 ",
                    },
                },
            ],
        },
    ],
};
